import {Base} from "@/api/Base"

export class DepartmentDelete extends Base {
    path = "department/delete"
}